import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { injectIntl, FormattedNumber } from 'react-intl';
import { Row, Col, Alert } from 'react-bootstrap';
import { getOrderLabels } from 'helpers/order';
import OrderActions from 'components/layout/order/OrderActions';
import OrderItemsCustomer from 'components/layout/order/OrderItemsCustomer';
import IntlDate from 'components/layout/IntlDate';
import IntlDateTime from 'components/layout/IntlDateTime';

class OrderInfosCustomer extends React.Component {
  getOrderTitle = () => {
    const {
      intl: { messages },
      order,
    } = this.props;

    const labels = getOrderLabels(order, messages);

    switch (order.type) {
      case 'car_rent': {
        return (
          <h4>
            {labels}
            {messages.orderTypes.car_rent}{' '}
            <span class="hint-text">
              <IntlDateTime date={order.date_from} /> - <IntlDateTime date={order.date_to} />
            </span>
          </h4>
        );
      }

      case 'car_sales': {
        return labels ? (
          <h4>
            {labels}

            {messages.orderTypes.car_sales}
          </h4>
        ) : null;
      }

      case 'item_sales': {
        return labels ? (
          <h4>
            {labels}

            {messages.order}
          </h4>
        ) : null;
      }

      case 'car_service': {
        return labels ? (
          <h4>
            {labels}
            {messages.orderTypes.car_service}{' '}
            <span class="hint-text">
              <IntlDateTime date={order.date_from} />
            </span>
          </h4>
        ) : null;
      }
    }

    return null;
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      order,
    } = this.props;

    let detailsLink = appIntl.urlPrefix + 'account/orders/' + order.id;
    let orderDateName = messages.order_placed;
    let orderTypeName = messages.order;
    let detailsLinkName = messages.show_order_details;
    if (order.type === 'car_service') {
      detailsLink = appIntl.urlPrefix + 'account/carServices/' + order.id;
      orderDateName = messages.car_service_booked_at;
      orderTypeName = messages.car_service_appointment;
      detailsLinkName = messages.show_booking_details;
    }
    let linkToInvoices = appIntl.urlPrefix + 'account/settings/invoices';

    return (
      <div class="panel b-rad-lg no-overflow b-grey">
        <div class="bg-master-lightest menuclipper padding-20 sm-padding-10">
          <Row>
            <Col xs={12} sm={4}>
              <div class="font-secondary no-margin text-uppercase">{orderDateName}</div>
              <div>
                <IntlDate date={order.cdate} />
              </div>
            </Col>
            <Col xs={12} sm={4}>
              {!!order.sum_gross && (
                <React.Fragment>
                  <div class="font-secondary no-margin text-uppercase">{messages.salesDoc.total}</div>
                  <div>
                    <FormattedNumber value={order.sum_gross} style="currency" currency={order.currency} />
                  </div>
                </React.Fragment>
              )}
            </Col>
            <Col xs={12} sm={4}>
              <div class="text-right xs-text-left font-secondary no-margin text-uppercase">
                {orderTypeName} <strong>#{order.id}</strong>
              </div>
              <div class="text-right xs-text-left">
                <Link to={detailsLink}>{detailsLinkName}</Link>
                <span class="m-l-10 m-r-10 hint-text">|</span>
                <Link to={linkToInvoices}>{messages.salesDoc.invoices}</Link>
                {/*
                  <OverlayTrigger
                    container={this}
                    trigger="click"
                    rootClose
                    placement="bottom"
                    overlay={
                      <Popover id={'order-invoices-' + order.id}>
                        <IntlProvider locale={appIntl.locale} messages={appIntl.messages.messages}>
                          <OrderInvoicesPopover order={order} />
                        </IntlProvider>
                      </Popover>
                    }
                  >
                    <a href="javascript:;" class="inline">
                      {messages.salesDoc.invoice} <i class="fas fa-angle-down" />
                    </a>
                  </OverlayTrigger>
                */}
              </div>
            </Col>
          </Row>
        </div>
        <div class="panel-body">
          <Row>
            <Col sm={12} md={8}>
              {/* order title */}
              {this.getOrderTitle()}

              {order.type === 'car_rent' ? (
                <Alert>
                  <span class="bold">{messages.pick_up_and_drop_off}:</span>
                  <br />
                  {order.pickup_location.name}, {order.pickup_location.street} {order.pickup_location.house_number}{' '}
                  {order.pickup_location.apartment_number}, {order.pickup_location.zip_code}{' '}
                  {order.pickup_location.city}
                </Alert>
              ) : null}

              {order.type !== 'car_rent' && order.type !== 'car_service' && order.shipping === 'pickup' ? (
                <Alert>
                  <span class="bold">{messages.desired_pickup_location}:</span>
                  <br />
                  {order.pickup_location.name}, {order.pickup_location.street} {order.pickup_location.house_number}{' '}
                  {order.pickup_location.apartment_number}, {order.pickup_location.zip_code}{' '}
                  {order.pickup_location.city}
                </Alert>
              ) : null}

              {order.type === 'car_service' ? (
                <Alert>
                  <span class="bold">{messages.service_location}:</span>
                  <br />
                  {order.pickup_location.name}, {order.pickup_location.street} {order.pickup_location.house_number}{' '}
                  {order.pickup_location.apartment_number}, {order.pickup_location.zip_code}{' '}
                  {order.pickup_location.city}
                </Alert>
              ) : null}

              {/* item list */}
              <OrderItemsCustomer order={order} />
            </Col>
            <Col xsHidden smHidden md={4}>
              <OrderActions order={order} key={'order-actions' + order.id} />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(OrderInfosCustomer)));
